// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Polaris-TextField__Input {\n  line-height: 1.5;\n  text-indent: 2px;\n}\n", "",{"version":3,"sources":["webpack://./js/pages/onboarding-v2/welcome.css"],"names":[],"mappings":"AAAA;EACI,gBAAgB;EAChB,gBAAgB;AACpB","sourcesContent":[".Polaris-TextField__Input {\n    line-height: 1.5;\n    text-indent: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
